export class LoadTemplatesForced {
    public static readonly type = '[DataCollection] Load templates forced';
}
